import useActivePosition from 'hooks/models/position/useActivePosition';
import useProjectPlanningIsEnabled from '../useProjectPlanningIsEnabled/useProjectPlanningIsEnabled';

export default function useProjectPlanningViewableByActivePosition() {
  const activePosition = useActivePosition();
  return useProjectPlanningIsEnabled() && activePosition?.manageResourcePlanning === true;
}
